var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { InputAdornment } from "@mui/material";
import { CardLogoData } from "../card-logo/CardLogoData";
import { PlaceholderLogo } from "../card-logo/placeholder-logo";
import { useEffect } from "react";
export var CardLogoComponent = function (_a) {
    var _b;
    var cardType = _a.cardType;
    useEffect(function () {
    }, [cardType]);
    return (_jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx("svg", { children: ((_b = CardLogoData.find(function (i) { return i.label == (cardType ? cardType.type : 'placeholder'); })) === null || _b === void 0 ? void 0 : _b.value) || _jsx(PlaceholderLogo, {}), width: "1.5em", height: "1em", viewBox: "0 0 24 16" }) })));
};
